<template>
  <div class="report-item editor-component" :style="themeStyle">
    <div class="wrapper">
      <svg
        width="427px"
        height="406px"
        viewBox="0 0 427 406"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
        <title>Flower</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="Flower"
            transform="translate(-4.000000, 0.000000)"
            stroke="#000000"
          >
            <path
              @click="saveAnswer('red', 1, 5)"
              d="M82.5,100.618034 L4.62562266,157.197081 L34.3709879,248.743902 L130.629012,248.743902 L160.374377,157.197081 L82.5,100.618034 Z"
              id="red"
              fill="#FF0000"
            ></path>
            <path
              @click="saveAnswer('yellow', 1, 5)"
              d="M352.5,100.618034 L274.625623,157.197081 L304.370988,248.743902 L400.629012,248.743902 L430.374377,157.197081 L352.5,100.618034 Z"
              id="yellow"
              fill="#FFEC00"
            ></path>
            <path
              @click="saveAnswer('purple', 1, 5)"
              d="M299.5,256.618034 L221.625623,313.197081 L251.370988,404.743902 L347.629012,404.743902 L377.374377,313.197081 L299.5,256.618034 Z"
              id="purple"
              fill="#FF00EE"
            ></path>
            <path
              @click="saveAnswer('green', 1, 5)"
              d="M216.5,0.618033989 L138.625623,57.197081 L168.370988,148.743902 L264.629012,148.743902 L294.374377,57.197081 L216.5,0.618033989 Z"
              id="green"
              fill="#00FF02"
            ></path>
            <path
              @click="saveAnswer('blue', 1, 5)"
              d="M134.5,256.618034 L56.6256227,313.197081 L86.3709879,404.743902 L182.629012,404.743902 L212.374377,313.197081 L134.5,256.618034 Z"
              id="blue"
              fill="#567EFF"
            ></path>
            <path
              @click="saveAnswer('cyan', 1, 5)"
              d="M216.898437,141.692253 L139.02406,198.2713 L168.769425,289.818121 L265.02745,289.818121 L294.772815,198.2713 L216.898437,141.692253 Z"
              id="cyan"
              fill="#00EDFF"
              transform="translate(216.898437, 223.574219) rotate(35.000000) translate(-216.898437, -223.574219) "
            ></path>
          </g>
        </g>
      </svg>
    </div>
    <PoweredBy v-if="shouldShowFooterElements"></PoweredBy>
  </div>
</template>
<script>
import Utilities from "../lib/Utilities";
import CCFooter from "./CCFooter";
import PoweredBy from "./PoweredBy";
import Velocity from "velocity-animate";
export default {
  props: {
    config: {
      default: () => {},
      type: Object
    },
    editable: { default: true, type: Boolean },
    theme: {
      type: Object,
      default: () => {}
    },
    actions: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  provide() {
    return {
      editable: this.editable
    };
  },
  inject: ["convince"],
  components: {
    CCFooter,
    PoweredBy
  },
  created() {
    this.content = this.config;
    this.getData();
  },
  data() {
    return {
      content: {},
      resultData: {},
      layoutReady: false
    };
  },
  computed: {
    shouldShowFooterElements() {
      return this.$store.getters.isResultPage && this.layoutReady;
    },
    layoutKey() {
      return Utilities.key();
    },
    themeStyle() {
      return {
        backgroundColor: this.content.backgroundColor,
        color: this.content.textColor
      };
    },
    titleSize() {
      return this.content.titleFontSize || 100;
    },
    textSize() {
      return this.content.textFontSize || 100;
    }
  },
  methods: {
    saveAnswer(key, value, score = 0) {
      this.$store.dispatch("save", {
        key: key,
        answer: { value: value, score: score }
      });
      const selection = this.$el.querySelector(`#${key}`);

      let animationTime = 1000;
      let options = {
        duration: animationTime,
        delay: false,
        easing: "ease-out"
      };

      Velocity(selection, { opacity: 0 }, options);
    },
    async getData() {
      await this.$store.dispatch("start");

      const [scoreResponse, agreementResponse] = await Promise.all([
        this.$store.dispatch("getScores"),
        this.convince.result()
      ]);

      this.$set(this.resultData, "scores", scoreResponse);
      for (const prop in agreementResponse.data) {
        this.$set(this.resultData, prop, agreementResponse.data[prop]);
      }
      this.$store.commit("setResult", this.resultData);
      this.scoresReady = true;
      this.$emit("ready");
    },
    getScores() {
      this.$store.dispatch("getScores").then((result) => {
        this.scoresReady = true;
      });
    }
  }
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.wrapper {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
